import { SET_SELECTION_FINANCE, SET_SELECTION_FINANCE_ENTITY } from './types/index';
import { getFinances } from '../apis/firebase';

export const setFinances = (dateRange, type, shops, isAllShops) => async dispatch => {
  const finances = await getFinances(dateRange, type, shops, isAllShops);
  if (type) {
    dispatch({ type, payload: finances });
  }
};

export const setSelectionFinance = selected => async dispatch => {
  dispatch({ type: SET_SELECTION_FINANCE, payload: selected });
};

export const setSelectionFinanceEntity = selected => async dispatch => {
  dispatch({ type: SET_SELECTION_FINANCE_ENTITY, payload: selected });
};
